
















































































































import { Component } from 'vue-property-decorator';
import { Base } from '../common/base';
import { PartSaleCustomerModel } from '@/models/fixedops/partsales';
import {customerService} from '@/shared';

@Component({
    watch: {
        customerInfo(newVal, oldVal) {
            this.getCustomerInfo(newVal);
        },
    },
    props: ['customerInfo'],
})
export default class PartSaleCustomerInformationComponent extends Base {
    public customerInfo: PartSaleCustomerModel;
    // public customerService: CustomerService;
    public isLoaded: boolean = false;
    public iscustomerInformationLoading: boolean = false;

    public mounted(): void {
        // this.customerService = new CustomerService();
    }

    public close(): void {
        this.$emit('onClose');
    }

    public async getCustomerInfo(model: PartSaleCustomerModel): Promise<void> {
        try {
            this.iscustomerInformationLoading = true;
            this.isLoaded = false;
            const response = await customerService.getCustomerInfoAsync(
                model.customerKey,
            );

            const keys = Object.keys(response);
            keys.forEach((key) => {
                model[key] = response[key];
            });
            this.customerInfo = model;
            this.isLoaded = true;
        } catch (e) {
            this.close();
        } finally {
            this.iscustomerInformationLoading = false;
        }
    }
}
